import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'

import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import BodymovinSegments from 'components/bodymovin/bodymovin_segments'
import { localize } from 'helpers/translator'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import adminOnboardingActions from 'redux/actions/adminOnboardingActions'
import adminOnboardingAddTeachersSelector from 'redux/selectors/admin_onboarding/admin_onboarding_add_teachers_selector'
import styles from './AddTeachers.scss'

import icon from 'assets/views/admin_onboarding/clock.svg'

const shareSegments = {
	start: {segment: [[0, 72], [72, 205]], loop: true},
	exit: {segment: [205, 223], loop: false},
}

class AddTeachers extends PureComponent {

	componentDidMount() {
		return this.props.actions.addTeachersInitializeView()
	}

	constructor() {
		super()
		this.state = {
			componentStatus: 'init',
		}
		this.shareListeners = {
			onLoaded: this.startAnimation.bind(this),
			onComplete: this.animationCompleted.bind(this),
		}
	}

	startAnimation() {
		this.setState({
			componentStatus: 'start',
		})
	}

	animationCompleted() {
		this.props.animationCompleted()
	}

	getStrongTitle(usersCount) {
		return `${localize('admin_onboarding_add_teachers_subtitle_part1')} ${usersCount} ${localize('admin_onboarding_add_teachers_subtitle_part2')}`
	}

	createAsset() {
		return (
			<BodymovinSegments
				settings={{
					path: '/assets/media/animations/share.json',
				}}
				segments={shareSegments}
				segment={this.state.componentStatus}
				listeners={this.shareListeners}
			>
				<div style={{
					width: '100%',
					height: '100%',
				}}></div>
			</BodymovinSegments>
		)
	}

	render() {

		return (
			<FullOverlay
				notificationIcon={icon}
				notificationText={this.props.offerTitle}
				title={localize('admin_onboarding_add_teachers_title')}
				strongTitle={this.getStrongTitle(this.props.usersCount)}
				assetSource={this.createAsset()}
				assetWidth='549px'
				assetHeight='254px'
				primaryTextButton={localize('admin_onboarding_add_teachers_primary_button_text')}
				primaryActionHandler={this.props.actions.shareColleaguesAction}
			/>
		)
	}
}

function mapStateToProps(state) {
	return adminOnboardingAddTeachersSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		addTeachersInitializeView: adminOnboardingActions.addTeachersInitializeView,
		shareColleaguesAction: adminOnboardingActions.addTeachersShareColleagues,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(AddTeachers, styles, { allowMultiple: true }))
